import { apiGet, apiPost, apiPut, apiDelete } from '../helpers/ApiHelper';
import Auth from 'j-toker';
import moment from 'moment';

import * as notifications from './notificationActions';
import * as validator from '../helpers/Validator';
import * as formatter from '../helpers/Formatter';
import { setAccentColor, setLandlordLogo } from './userTypesActions';

function setUnitTypes(unitTypes) {
  return {
    type: 'LANDLORD_USER::STORE_UNIT_TYPES',
    unitTypes,
  };
}

export function getLandlord(id) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/landlord/${id}`)
        .done(response => {
          dispatch(setAccentColor(response.landlord_details.accent_color));
          dispatch(setLandlordLogo(response.landlord_details.logo_url));
          dispatch(setUnitTypes(response.landlord_details.unit_types));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getUsers() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/landlords/users')
        .done(response => {
          if (response.users.length) {
            const formattedResponse = response.users.map(user => {
              for (let key in user) {
                if (['phone_number', 'mobile_number', 'office_number'].includes(key)) {
                  user[key] = validator.normalizePhone(user[key]);
                }
              }
              if (user.last_sign_in_at) {
                user.last_sign_in_at = moment(user.last_sign_in_at)
                  .local()
                  .locale('en');
              }
              return user;
            });
            dispatch(displayUsers(formattedResponse));
          }

          dispatch(saveRoles(response.roles));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getUsersStats() {
  const route = '/landlords/users_stats';
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_USER::FETCH_USERS_STATS',
      payload: apiGet(Auth.getApiUrl() + route).done(response => {
        dispatch({
          type: 'LANDLORD_USER::SAVE_USERS_STATS',
          payload: response.detailed_users_counts,
        });
      }),
    });
  };
}

export function getFilteredUsers(subset = 'all', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_USER::FETCH_USERS',
      payload: apiPost(
        `${Auth.getApiUrl()}/landlords/filtered_users?subset=${subset}&offset=${offset}`,
        options
      )
        .done(response => {
          if (response.users !== undefined) {
            const formattedResponse = response.users.map(user => {
              for (let key in user) {
                if (['phone_number', 'mobile_number', 'office_number'].includes(key)) {
                  user[key] = validator.normalizePhone(user[key]);
                }
              }
              if (user.last_sign_in_at) {
                user.last_sign_in_at = moment(user.last_sign_in_at)
                  .local()
                  .locale('en');
              }
              return user;
            });
            dispatch(
              displayFilteredUsers(formattedResponse, offset, response.search_total_results_count)
            );
          }
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function displayFilteredUsers(users, offset, searchTotalResultsCount) {
  return {
    type: 'LANDLORD_USER::SHOW_FILTERED_USERS',
    users,
    offset,
    searchTotalResultsCount,
  };
}

export function getRoles() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/landlords/roles')
        .done(response => {
          dispatch(saveRoles(response.roles));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getUser(userType, userId) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/user?user_type=${userType}&user_id=${userId}`)
        .done(response => {
          let user = response.user;
          if (user.last_sign_in_at) {
            user.last_sign_in_at = moment(user.last_sign_in_at)
              .local()
              .locale('en');
          }
          dispatch(displayUser(user));
          return user;
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function displayUsers(users) {
  return {
    type: 'LANDLORD_USER::SHOW_USERS',
    users,
  };
}

export function displayUser(user) {
  return {
    type: 'LANDLORD_USER::SHOW_USER',
    user,
  };
}

export function saveRoles(roles) {
  return {
    type: 'LANDLORD_USER::SAVE_ROLES',
    roles,
  };
}

export function postUser(data) {
  let data_clone = JSON.parse(JSON.stringify(data)); // needed so it does not change redux form data
  if (data_clone.user_type === 'Agent') {
    data_clone['office_number_extension'] = formatter.onlyNumbers(
      data_clone.office_number_extension,
      true
    );
  }
  if (data_clone.role && data_clone.role !== 'None') {
    data_clone['role_id'] = data_clone.role;
  }

  if (data_clone.properties) {
    data_clone['property_ids'] = data_clone['properties'].map(property => property.value);
  } else {
    data_clone['property_ids'] = [];
  }

  if (data_clone.showing_properties) {
    data_clone['showing_property_ids'] = data_clone['showing_properties'].map(
      property => property.value
    );
  } else {
    data_clone['showing_property_ids'] = [];
  }

  delete data_clone['properties'];

  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/landlords/users/', data_clone)
        .done(response => {
          dispatch(notifications.showSuccess('successfullyAddedUser'));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function deactivateUser(user_type, user_id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/users/${user_id}?user_type=${user_type}`)
        .done(response => {
          dispatch(notifications.showSuccess('successfullyDeactivatedUser'));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function reactivateUser(user_type, user_id, permissions) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/users/${user_id}?user_type=${user_type}`, {
        active: true,
        permissions,
      })
        .done(response => {
          dispatch(notifications.showSuccess('successfullyReactivatedUser'));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function sendInvitation(user_type, user_id) {
  return dispatch => {
    dispatch(closeOptionsMenu());
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/landlords/send_invitation', {
        user_type,
        user_id,
      })
        .done(response => {
          dispatch(notifications.showSuccess('successfullyInvitedUser'));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function sendPasswordReset(user_type, user_id) {
  return dispatch => {
    dispatch(closeOptionsMenu());
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/landlords/send_password_reset', {
        user_type,
        user_id,
      })
        .done(response => {
          dispatch(notifications.showSuccess('successfullySentPasswordResetLinkToUser'));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function openOptionsMenu(userDetails, anchorEl) {
  return {
    type: 'LANDLORD_USER::SHOW_OPTIONS_MENU',
    userDetails,
    anchorEl,
    shouldShow: true,
  };
}

export function closeOptionsMenu() {
  return {
    type: 'LANDLORD_USER::SHOW_OPTIONS_MENU',
    anchorEl: null,
    shouldShow: false,
  };
}

export function putUser(formData) {
  let data_clone = JSON.parse(JSON.stringify(formData)); // needed so it does not change redux form data
  if (data_clone.user_type === 'Agent') {
    data_clone['office_number_extension'] = formatter.onlyNumbers(
      data_clone.office_number_extension,
      true
    );
  }

  if (data_clone.properties) {
    data_clone['property_ids'] = data_clone['properties'].map(property => property.value);
  } else {
    data_clone['property_ids'] = [];
  }
  delete data_clone['properties'];

  if (data_clone.showing_properties) {
    data_clone['showing_property_ids'] = data_clone['showing_properties'].map(
      property => property.value
    );
  } else {
    data_clone['showing_property_ids'] = [];
  }
  delete data_clone['showing_properties'];

  data_clone['admin'] = data_clone.admin === true;

  data_clone['preference_attributes']['maintenance_notifications'] =
    data_clone['preference_attributes']['maintenance_notifications'] === true;
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/users/${data_clone.user_id}`, data_clone)
        .done(response => {
          dispatch(notifications.showSuccess('userSuccessfullyUpdated'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function putPermissions(userType, userId, formData) {
  let data_clone = JSON.parse(JSON.stringify(formData)); // needed so it does not change redux form data
  return (dispatch, getState) => {
    const requestBody = {
      user_type: userType,
      user_id: userId,
      permissions: data_clone,
    };

    if (data_clone.role) {
      requestBody['role_id'] = data_clone.role;
    }

    return dispatch({
      payload: apiPut(Auth.getApiUrl() + '/landlords/users/permissions', requestBody)
        .done(response => {
          dispatch(notifications.showSuccess('userSuccessfullyUpdated'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function resetUserCredentials(userId, userType) {
  return dispatch => {
    return dispatch({
      payload: apiPut(
        Auth.getApiUrl() + `/landlords/users/reset_token?user_id=${userId}&user_type=${userType}`
      )
        .done(response => {
          dispatch(notifications.showSuccess('userSuccessfullyUpdated'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}
